<template lang='pug'>
  v-container#user-profile(fluid="" tag="section")
    // Dialog
    v-dialog( :fullscreen='isMobile' persistent :value='updateItemDialog'  max-width='800px'   transition="dialog-bottom-transition")
      div(style ='position:relative; height: 100%;')
        update-item(:model ='profile' @close="updateItemDialog=false")
        div(style='position:absolute; top:0; width:100%;')
          v-btn.mt-2.ml-2(absolute right  icon color='danger' style="top: -45px; z-index:999;" medium,  dark='', @click.native='updateItemDialog=false')
            v-icon(size="30") mdi-close-box
    // Desktop
    v-card(v-if="!isMobile")
        v-toolbar(flat='' color='primary' dark='')
            v-toolbar-title {{$t('payment.userProfile.title')}}
        v-row.mt-5
            // Menu
            v-col(cols="4")
                base-material-card(:avatar="profile.image ? profile.image:userImage" flat)
                h3.text-center {{profile.name}} {{profile.last_name}}
                v-list(dense="")
                    v-list-item-group(v-model="item" color="primary")
                        v-list-item(v-for="(item, i) in items" :key="i")
                            v-list-item-avatar
                                v-icon(v-text="item.icon")
                            v-list-item-content
                                v-list-item-title(v-text="item.title")
                            v-list-item-action
                                v-btn(icon)
                                    v-icon mdi-chevron-right
                        // Cerrar sesion
                        v-list-item(@click="logout")
                            v-list-item-avatar
                                v-icon(v-text="'mdi-close'")
                            v-list-item-content
                                v-list-item-title(v-text="'Cerrar sesión'")
                            v-list-item-action
                                v-btn(icon)
                                    v-icon mdi-chevron-right
            // Contenido
            v-col(cols="8")
                v-card(flat)
                    v-alert(v-model="alert" color="primary" border="left" elevation="2" colored-border="")
                      v-row(align="center")
                        v-col.grow
                          v-icon(color="primary")
                            | mdi-sale
                          |  Comparte este codigo y recibe un cupón de descuento para tu proxima compra.
                          h1 {{profile.referal_code}}
                        v-col.shrink
                          v-btn(color="primary", @click="getReferralCode", :loading="gettingCode" :disabled="gettingCode" v-if="profile.referal_code===undefined") Obtener código
                        v-col(v-if="profile.referal_code!==undefined").shrink
                          v-btn(color="#25d366", :href="'https://wa.me/?text=Usa+mi+c%C3%B3digo+' + profile.referal_code + '+y+recibe+un+cup%C3%B3n+de+descuento+en+Tender+para+tu+pr%C3%B3xima+compra.'", target="_blank") Comparte
                            v-icon() mdi-whatsapp
                        v-col(v-if="profile.referal_code!==undefined").shrink
                          v-btn(color="#4267B2", :href="'https://m.me/?text=Usa+mi+c%C3%B3digo+' + profile.referal_code + '+y+recibe+un+cup%C3%B3n+de+descuento+en+Tender+para+tu+pr%C3%B3xima+compra.'", target="_blank") Comparte en&nbsp;
                            v-icon() mdi-facebook
                    // Mis detalles
                    v-card-text(v-if="item === 0 || !item")
                        v-row
                            v-col(cols="12")
                                h3 {{items[item].title}}
                            v-col(cols="12" md="6")
                                v-text-field(label="Nombre" disabled="" v-model="profile.name")
                            v-col(cols="12" md="6")
                                v-text-field.purple-input(label="Apellido" disabled="" v-model="profile.last_name")
                            v-col(cols="12" md="6")
                                v-text-field.purple-input(label="Email De Notificaiones" disabled="" v-model="profile.notification_email")
                            v-col(cols="12" md="6")
                                v-text-field.purple-input(label="Telefono" disabled="" v-model="profile.phone")
                        v-row(v-if="profile.direction")
                          v-col(cols="12")
                              h3 {{$t('user_profile.menu.my_address')}}
                          v-col(cols="12" md="6")
                              v-text-field(:label="$t('user_profile.direction.address')" disabled="" v-model="profile.direction.address")
                          //-
                            v-col(cols="12" md="6")
                                v-text-field.purple-input(:label="$t('user_profile.direction.street')" disabled="" v-model="profile.direction.street")
                          v-col(cols="12" md="6")
                              v-text-field.purple-input(:label="$t('user_profile.direction.city')" disabled="" v-model="profile.direction.city")
                          v-col(cols="12" md="6")
                              v-text-field.purple-input(:label="$t('user_profile.direction.state')" disabled="" v-model="profile.direction.state")
                        v-col(cols="12").text-center
                            v-btn.mr-0(color="primary" small @click.stop='updateItemDialog=true')
                                | {{$t('user_profile.detail_form.edit_profile_btn')}}
                    // Mis pedidos
                    v-card-text(v-if="item === 1")
                      v-row
                        v-col(cols="12")
                          h3 {{items[item].title}}
                          MyRequest
                    // Mis direcciones
                    v-card-text(v-if="item === 2")
                        v-row
                            v-col(cols="12")
                              h3 {{items[item].title}}
                              MyDirections
                    // Mis lugares favoritos
                    v-card-text(v-if="item === 3")
                        v-row
                            v-col(cols="12")
                                h3 {{items[item].title}}
                                MyFavorites
                    // Mis lugares favoritos
                    v-card-text(v-if="item === 4")
                        v-row
                            v-col(cols="12")
                                h3 {{items[item].title}}
                                Coupons
    v-container(v-else flat)
        Avatar(:profile="profile" @openUpdate="updateItemDialog=true")
        // Menu
        v-card(v-if="!itemMobile && itemMobile !== 0")
            v-list(dense="")
                v-list-item-group(v-model="itemMobile" color="primary")
                    v-list-item(v-for="(item, i) in items" :key="i")
                        v-list-item-avatar
                            v-icon(v-text="item.icon")
                        v-list-item-content
                            v-list-item-title(v-text="item.title")
                        v-list-item-action
                            v-btn(icon)
                                v-icon mdi-chevron-right
                    // Cerrar sesion
                    v-list-item(@click="logout")
                        v-list-item-avatar
                            v-icon(v-text="'mdi-close'")
                        v-list-item-content
                            v-list-item-title(v-text="'Cerrar sesión'")
                        v-list-item-action
                            v-btn(icon)
                                v-icon mdi-chevron-right
        // Content
        v-card(v-else)
          // Mis detalles
          v-card-text(v-if="itemMobile === 0 || !itemMobile")
              v-row
                  v-col(cols="12" @click="itemMobile = ''")
                      v-icon(left="") mdi-chevron-left
                      | {{items[itemMobile].title}}
                  v-col(cols="12" md="6")
                      v-text-field(label="Nombre" disabled="" v-model="profile.name")
                  v-col(cols="12" md="6")
                      v-text-field.purple-input(label="Apellido" disabled="" v-model="profile.last_name")
                  v-col(cols="12" md="6")
                      v-text-field.purple-input(label="Email De Notificaiones" disabled="" v-model="profile.notification_email")
                  v-col(cols="12" md="6")
                      v-text-field.purple-input(label="Telefono" disabled="" v-model="profile.phone")
              v-row(v-if="profile.direction" style="width: 100%")
                v-col(cols="12")
                    h3 {{$t('user_profile.menu.my_address')}}
                v-col(cols="12" md="6")
                    v-text-field(:label="$t('user_profile.direction.address')" disabled="" v-model="profile.direction.address")
                //-
                  v-col(cols="12" md="6")
                      v-text-field.purple-input(:label="$t('user_profile.direction.street')" disabled="" v-model="profile.direction.street")
                v-col(cols="12" md="6")
                    v-text-field.purple-input(:label="$t('user_profile.direction.city')" disabled="" v-model="profile.direction.city")
                v-col(cols="12" md="6")
                    v-text-field.purple-input(:label="$t('user_profile.direction.state')" disabled="" v-model="profile.direction.state")
              v-col(cols="12").text-center
                  v-btn.mr-0(color="primary" small @click.stop='updateItemDialog=true')
                      | {{$t('user_profile.detail_form.edit_profile_btn')}}
          // Mis pedidos
          v-card-text(v-if="itemMobile === 1")
            v-row
              v-col(cols="12" @click="itemMobile = ''")
                v-icon(left="") mdi-chevron-left
                | {{items[itemMobile].title}}
              v-col(cols="12")
                MyRequest
          // Mis direcciones
          v-card-text(v-if="itemMobile === 2")
              v-row
                v-col(cols="12" @click="itemMobile = ''")
                  v-icon(left="") mdi-chevron-left
                  | {{items[itemMobile].title}}
                v-col(cols="12")
                  MyDirections
          // mis lugares favoritos
          v-card-text(v-if="itemMobile === 3")
              v-row
                  v-col(cols="12" @click="itemMobile = ''")
                    v-icon(left="") mdi-chevron-left
                    | {{items[itemMobile].title}}
                  v-col(cols="12")
                    MyFavorites
          // mis cupones
          v-card-text(v-if="itemMobile === 4")
              v-row
                v-col(cols="12" @click="itemMobile = ''")
                  v-icon(left="") mdi-chevron-left
                  | {{items[itemMobile].title}}
                v-col(cols="12")
                  Coupons
</template>

<script>
  import loaders from '@/plugins/mixins/loaders'
  import UpdateItem from '@/views/custom/UpdateProfile'
  import userImage from '@/assets/user.png'
  import { auth } from '@/plugins/auth/firebase'
  import Cookie from 'js-cookie'
  export default {

    components: {
      UpdateItem: UpdateItem,
      Avatar: () => import('@/views/marketplace/component/profile/Avatar'),
      MyRequest: () => import('@/views/marketplace/component/profile/MyRequest'),
      MyFavorites: () => import('@/views/marketplace/component/profile/MyFavorites'),
      Planner: () => import('@/views/custom/plans/Planner'),
      MyDirections: () => import('@/views/marketplace/component/profile/UserDirections'),
      Coupons: () => import('@/views/marketplace/component/profile/Coupons'),
    },

    mixins: [loaders],
    props: {
      favorites: {
        type: String,
        default: 'default',
      },
    },
    data () {
      return {
        userImage: userImage,
        alert: true,
        model: {},
        updateItemDialog: false,
        item: 0,
        itemMobile: '',
        items: [
          { title: 'Mis Detalles', icon: 'mdi-account' },
          { title: 'Mis pedidos', icon: 'mdi-credit-card' },
          { title: 'Mis direcciones', icon: 'mdi-map-marker' },
          { title: 'Mis lugares favoritos', icon: 'mdi-heart' },
          { title: 'Mis cupones', icon: 'mdi-sale' },
        ],
        gettingCode: false,
      }
    },

    computed: {
      isMobile () {
        return window.innerWidth < 1024
      },
      profile () {
        return this.$store.getters['users/getProfile']
      },
    },

    created () {
      const vm = this
      vm.banProgresBar = true
      if (vm.favorites === 'favorites') {
        vm.item = 3
        vm.itemMobile = 3
      }
      vm.loadProfile()
    },

    methods: {
      getReferralCode () {
        this.gettingCode = true
        this.$store.dispatch('referrals/codeGenerator', function () {
          // Codigo generado
        }).then(() => {
          this.gettingCode = false
        })
      },
      async logout () {
        const vm = this
        // console.log('logout')
        await auth.signOut()
        await Cookie.remove('access_token')
        vm.$store.dispatch('users/clearUser').then(function () {
          vm.$router.push('/').catch(err => {
            console.log(err)
          })
        })
      },
    },
  }
</script>
<style lang="scss">
  .profile__container{
    display: flex;
    flex-direction: column-reverse;
    @media (min-width : 600px){
      flex-direction: row;
      flex-wrap: nowrap;
    }
  }
</style>
